var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import React from "react";
export default ((_ref) => {
  let {
    styles = {}
  } = _ref,
      props = _objectWithoutProperties(_ref, ["styles"]);

  return React.createElement(
    "svg",
    _extends({ xmlns: "http://www.w3.org/2000/svg", width: "60", height: "60", viewBox: "0 0 60 60" }, props),
    React.createElement(
      "g",
      { fill: "none", fillRule: "evenodd" },
      React.createElement("circle", { cx: "30", cy: "30", r: "29.5", stroke: "#43C6AC" }),
      React.createElement("path", { fill: "#43C6AC", stroke: "#FFF", strokeWidth: ".1", d: "M44.47 20.14a.63.63 0 0 0-.9 0L24.54 39.19l-8.22-8.22a.63.63 0 0 0-.89.89l8.66 8.66a.62.62 0 0 0 .9 0l19.49-19.5a.63.63 0 0 0 0-.88" })
    )
  );
});